import { render } from "./cardList.vue?vue&type=template&id=58496869&scoped=true"
import script from "./cardList.vue?vue&type=script&lang=js"
export * from "./cardList.vue?vue&type=script&lang=js"

import "./cardList.vue?vue&type=style&index=0&id=58496869&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58496869"]])

export default __exports__